import { useEffect, useState } from 'react';
import api from '../../utils/api';
import { useAuth, isTTC } from '../../hooks/useAuth';
import { AddressBookManager } from '../../components/AddressBook';

export default function AddressesAdminPage() {
  const { user } = useAuth();
  const ttc = isTTC(user);
  const [customers, setCustomers] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!ttc) return; // customer admins are scoped to their own customer (no customer list)
    api.get('/api/customers').then(r => {
      const active = r.data.customers.filter(c => c.active);
      setCustomers(active);
      if (active.length === 1) setSelected(active[0]);
    }).catch(() => {});
  }, [ttc]);

  // Customer admin: manage only their own customer's ship-to addresses.
  if (!ttc) {
    return (
      <>
        <div className="topbar"><h2>Address Book</h2></div>
        <div className="page">
          {user?.customer_id
            ? <AddressBookManager customerId={user.customer_id} />
            : <div className="card empty-state"><p>No customer is associated with your account.</p></div>}
        </div>
      </>
    );
  }

  // TTC staff/admins: pick a customer, then manage their addresses.
  return (
    <>
      <div className="topbar"><h2>Address Book</h2></div>
      <div className="page">
        {customers.length > 1 && (
          <div className="form-group" style={{ maxWidth: 320, marginBottom: 20 }}>
            <label className="form-label">Customer</label>
            <select
              className="form-select"
              value={selected?.id || ''}
              onChange={e => setSelected(customers.find(c => c.id === parseInt(e.target.value)) || null)}
            >
              <option value="">— Select customer —</option>
              {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
        )}

        {selected ? (
          <AddressBookManager customerId={selected.id} />
        ) : (
          <div className="card empty-state">
            <p>Select a customer to manage their ship-to addresses.</p>
          </div>
        )}
      </div>
    </>
  );
}
